<template>
  <LocationCell
    :country="column.clientCountry?.name ?? '—'"
    :country-code="column.clientCountry?.isoCode ?? null"
    :detail="column.client.region?.name ?? null"
    :data-test="`agency-client-location-${rowIndex}`"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import LocationCell from '@/components/LocationCell.vue'

const StaffingAgencyClientLocationColumn = graphql(`
  fragment StaffingAgencyClientLocationColumn on SupplierClient {
    id
    clientCountry {
      isoCode
      name
    }
    client {
      id
      region {
        id
        name
      }
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof StaffingAgencyClientLocationColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(StaffingAgencyClientLocationColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)

</script>
